import { useGetFlightInfoQuery, useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { SegmentBaggageLoader } from '@/src/components/desktop/itinerary/loadingShimmers'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
// import { formatBaggageInfo } from '@/src/utils/translation/translateBaggage'
import { useTranslations } from 'next-intl'
import SegmentBaggage from './segmentBaggage'

interface SegmentBaggageWrapperProps {
    segmentKey: string
    /** From segmentData.baggage - format { cab, cib, freeText } (same as API) */
    baggage?: { cab?: string; cib?: string; freeText?: string; additionalBaggage?: string; fareType?: string } | null
}

const SegmentBaggageWrapper = ({ segmentKey, baggage: baggageProp }: SegmentBaggageWrapperProps) => {
    const itineraryId = useGetItineraryId()
    const t = useTranslations('common')
    const tTripDetails = useTranslations('tripDetails')
    // const locale = useLocale()
    const { meta } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            skip: !!baggageProp,
            selectFromResult: ({ data }) => ({
                meta: data?.meta || {}
            })
        }
    )
    const { fareFamilyEnabledOnReview } = meta
    const {
        data,
        isLoading: isFlightMinirulesInfoLoading,
        isUninitialized
    } = useGetFlightInfoQuery(
        {
            itineraryId
        },
        {
            skip: fareFamilyEnabledOnReview || !!baggageProp
        }
    )

    const baggageData = data?.freeBaggageInfoResponse?.BI?.[segmentKey]
    const apiCab = baggageData?.cab ?? ''
    const apiCib = baggageData?.cib ?? ''
    const apiFreeText = baggageData?.freeText ?? ''

    const viewBaggageCta = t('viewBaggageCta')
    const cabinBaggageCta = t('cabinBaggage')
    const checkinBaggageCta = t('checkinBaggage')
    const extrasCta = t('extras')
    const fareTypeLabel = tTripDetails('fareType')
    const additionalBaggageLabel = tTripDetails('additionalBaggage')
    const notAllowedText = t('Not allowed')

    const cab = baggageProp ? (baggageProp.cab ?? '') : apiCab
    const cib = baggageProp ? (baggageProp.cib ?? '') : apiCib
    const freeText = baggageProp ? (baggageProp.freeText ?? '') : apiFreeText
    const additionalBaggage = baggageProp?.additionalBaggage ?? ''
    const fareType = baggageProp?.fareType ?? ''

    if (baggageProp) {
        if (!cab && !cib && !freeText && !additionalBaggage) return null
    } else {
        if (fareFamilyEnabledOnReview || isUninitialized) return null
        if (isFlightMinirulesInfoLoading) return <SegmentBaggageLoader />
        if (!cab && !cib && !freeText && !additionalBaggage) return null
    }

    return (
        <SegmentBaggage
            cab={cab || notAllowedText}
            cib={cib || notAllowedText}
            freeText={freeText}
            additionalBaggage={additionalBaggage}
            fareType={fareType}
            additionalBaggageLabel={additionalBaggageLabel}
            fareTypeLabel={fareTypeLabel}
            viewBaggageCta={viewBaggageCta}
            extrasCta={extrasCta}
            cabinBaggageCta={cabinBaggageCta}
            checkinBaggageCta={checkinBaggageCta}
        />
    )
}

export default SegmentBaggageWrapper
